module.exports = __webpack_public_path__ + "static/People2-3x-65e46660eb07aaf66d3639fe160f55da.png";